module.exports = __webpack_public_path__ + "img/odc.2be37054.svg";